import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BossStateService } from './boss-state.service';
import { BossEffects } from './store/effects';
import { BossReducer } from './store/reducer';
import { BossService } from './services/boss.service';
import { stateName } from './store/state';

@NgModule({
  imports: [
    StoreModule.forFeature(stateName, BossReducer),
    EffectsModule.forFeature([BossEffects]),
  ],
  declarations: [],
  providers: [BossService, BossStateService],
})
export class BossStateModule {}
